import { getCSSValue as o } from "./get-css-value.js";
const i = (r) => r && typeof r == "boolean" ? "999px" : o(r, "border-radius");
export {
  i as getBorderRadius
};
